import { useCurrentUserCompanyId } from 'hooks/company';
import { useSnackbar } from 'notistack';

import { useGetDashboardV2VInfoQuery } from '@libs/graphql-types';

export const useDashboardData = () => {
  const { enqueueSnackbar } = useSnackbar();
  const companyId = useCurrentUserCompanyId();
  const { loading, data } = useGetDashboardV2VInfoQuery({
    fetchPolicy: 'network-only',
    onError: () => enqueueSnackbar('Filed to load data', { variant: 'error' }),
    variables: { company_id: companyId! },
  });

  return { data, loading };
};
